"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lightTheme = function (_a) {
    return ({
        palette: { type: 'light' },
        overrides: {
            MuiCssBaseline: {
                "@global": {
                    "@media print": {
                        "html, body, #__next": {
                            overflow: "initial",
                        },
                        "#scroll-root": {
                            "overflow-y": "initial"
                        }
                    },
                }
            }
        }
    });
};
exports.default = lightTheme;
//# sourceMappingURL=index.js.map